import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    flex: '1 1 100%',
    backgroundColor: theme.palette.white,
  },
  mobileRoot: {
    flexDirection: 'column',
  },
}))

export default useStyles
